import "./new-contract.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormContract from "../form-contract/form-contract";
import { useNewContract } from "./new-contract.hook";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import PrintWaiver from "../print-waiver/print-waiver";
import { GetWaiverModel } from "@factory/model/query-model-waiver";

export function NewContract() {
  const {
    isCreating,
    formMethod,
    patient,
    doctor,
    service,
    session,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewContract();
  const [previewWaiver, setPreviewWaiver] = useState(false);
  const [selectedWaiver, setSelectedWaiver] = useState<GetWaiverModel | null>(
    null
  );
  const handleSetWaiver = (waiver: GetWaiverModel) => {
    setSelectedWaiver(waiver);
    setPreviewWaiver(true);
  };

  const printWaiver = (
    <Dialog
      header="Waiver Preview"
      visible={previewWaiver}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!previewWaiver) return;
        setPreviewWaiver(false);
      }}
    >
      <PrintWaiver
        fontSize={selectedWaiver?.font_size || 11}
        subTitle={selectedWaiver?.sub_title || ""}
        title={selectedWaiver?.name || ""}
        waiverText={selectedWaiver?.description || ""}
        session={session || 0}
        patient={patient || ""}
        doctor={doctor || ""}
        service={service || ""}
        signature={null}
      />
    </Dialog>
  );

  return (
    <div id="NewContract" className="contract">
      <HeaderContent
        title={<h1>New Contract</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          {printWaiver}
          <section className="grid grid-cols-1 gap-2 mb-4">
            <FormContract isNew={true} handleWaiverPreview={handleSetWaiver} />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewContract;
